import axios from "axios";

const noAuthAxios = axios.create({
	headers: {
		'Content-Type': 'application/json',
	},
});

export default noAuthAxios;